<script>
export default {
  name: 'doc-table',
  props: {
    fonts: {type: Array, default: () => []},
    formats: {type: Array, default: () => []},
    header: {type: Array, default: () => []},
    rows: {type: Array, default: () => []}
  }
}
</script>

<template>
<v-simple-table class='doc-table'>
  <thead>
    <tr><th v-for='(h, i) in header' :key='i'>{{h}}</th></tr>
  </thead>
  <tbody class='doc-table'>
    <tr v-for='(row, j) in rows' :key='j'>
      <td v-for='(col, k) in row' :key='k' :class='fonts[k]'>
        <ul v-if='formats[k] === `list`' class='my-1'>
          <li v-for='(str, l) in col' :key='l'>{{str}}</li>
        </ul>
        <div v-else class='my-1'>{{col}}</div>
      </td>
    </tr>
  </tbody>
</v-simple-table>
</template>

<style lang='sass' scoped>
.doc-table
  td
    letter-spacing: 0.05em
  th
    font-size: 1.1em !important
  tr
    &:hover
      background-color: transparent !important
  td
    li
      white-space: nowrap
</style>
